// extracted by mini-css-extract-plugin
export default {"Drumpads":"Drumpads_Drumpads__YcLK0","DrumpadsGrid":"Drumpads_DrumpadsGrid__zUB6q"};